<template>
  <v-container>
    <landing-create :content="content"></landing-create>
    <method-of-collection-form
      :isLoading="isLoading"
      :onSubmit="onSubmit">
    </method-of-collection-form>
  </v-container>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import MethodOfCollectionForm from './MethodOfCollectionForm.vue';
import services from '../../../services';
import utilities from '../../../utilities';

const { ErrorMessageUtil } = utilities;
const { biobankRegistry } = services;
const { methodOfCollectionService } = biobankRegistry;

export default {
  name: 'MethodOfCollectionCreate',
  components: {
    MethodOfCollectionForm,
    LandingCreate,
  },
  data: () => ({
    isLoading: false,
    content: {
      pageTitle: 'Create Method of Collection',
      enableBackButton: true,
    },
  }),
  methods: {
    async onSubmit(data) {
      this.isLoading = true;
      try {
        const { _id: id } = await methodOfCollectionService.create({ methodOfCollection: data });

        this.$snackbar.showOk({ text: 'Successfully created Collection Method!' });

        this.$router.replace({ name: 'method-of-collection.edit', params: { id } });
      } catch (e) {
        const error = e.response.data;
        this.$snackbar.showBad({
          text: ErrorMessageUtil.transform(error),
        });
      }
      this.isLoading = false;
    },
  },
};
</script>
